import {Overlay} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/Overlay';
import {Page} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/Page';
import {OverlayMenuItemRenderer} from '@mintdata-wsp/wsp/ui/views/visualDesigner/surface/panels/outline/pages/overlaysMenu/OverlayMenuItemRenderer';
import {IListItemState} from '@mintdata/mint-kit/api/models/List';
import {
    ContextMenu,
    PopupAnchor,
    SourceAnchor,
    ToggleOn
} from '@mintdata/mint-kit/impl/components/contextMenu/ContextMenu';
import {IListItemData} from '@mintdata/mint-kit/impl/components/list/ListView';
import {ImgIcon} from '@mintdata/mint-kit/impl/properties/components/imgIcon/ImgIcon';
import {ImgIcons} from '@mintdata/mint-kit/impl/properties/components/imgIcon/ImgIcons';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';
import {IStyles} from '@mintdata/mint-kit/impl/util/Styles';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./OverlaysMenu.less');
const cx = classnames.bind(styles);

export interface OverlaysMenuProps
{
    page:Page,
    className?:string,
}

export interface IOverlaysMenuItem<Overlay> extends IListItemData<Overlay>
{
    pageOverlayHost:Page,
    isActive?:boolean,
    isInPinned?:boolean,
    isHeader?:boolean,
    isSeparator?:boolean,
}

@observer
export class OverlaysMenu extends React.Component<OverlaysMenuProps, any>
{
    private _contextMenuTriggerId:string = IdUtil.newComponentId();

    private static _renderItem(data:IOverlaysMenuItem<Overlay>, state:IListItemState, styles:IStyles):JSX.Element
    {
        return <OverlayMenuItemRenderer
            overlay={data.value}
            isHeader={data.isHeader}
            isActive={data.isActive}
            isInPinned={data.isInPinned}
            isSeparator={data.isSeparator}
            pageOverlayHostId={data.pageOverlayHost.id}
        />;
    }

    private _getMenuItems(page:Page):IOverlaysMenuItem<Overlay>[]
    {
        const overlaysHeader:IOverlaysMenuItem<Overlay> = {
            pageOverlayHost: page,
            isHeader: true,
        };

        const pinnedOverlaysHeader:IOverlaysMenuItem<Overlay> = {
            pageOverlayHost: page,
            isHeader: true,
            isInPinned: true
        };

        const separator = {
            pageOverlayHost: page,
            isSeparator: true,
        };

        let overlaysMenuItems:IOverlaysMenuItem<Overlay>[] = [];
        let pinnedOverlaysMenuItems:IOverlaysMenuItem<Overlay>[] = [];

        page.overlays.forEach((overlay:Overlay) => {
            const isActive:boolean = page.activeOverlay === overlay;

            if (overlay.isPinned)
            {
                pinnedOverlaysMenuItems.push(
                    {
                        value: overlay,
                        pageOverlayHost: page,
                        isHeader: false,
                        isInPinned: true,
                        isActive,
                    }
                );
            }
            else
            {
                overlaysMenuItems.push(
                    {
                        value: overlay,
                        pageOverlayHost: page,
                        isHeader: false,
                        isInPinned: false,
                        isActive,
                    }
                );
            }
        });

        let result:IOverlaysMenuItem<Overlay>[] = [];
        const overlaysMenuItemsLength:number = overlaysMenuItems.length;

        if (pinnedOverlaysMenuItems.length > 0)
        {
            result = result.concat(pinnedOverlaysHeader, pinnedOverlaysMenuItems);

            if (overlaysMenuItemsLength > 0)
                result.push(separator);
        }


        if (overlaysMenuItemsLength > 0)
            result = result.concat(overlaysHeader, overlaysMenuItems);

        return result;
    }

    render()
    {
        const {page, className} = this.props;

        return (
            <ContextMenu
                toggleOn={[ToggleOn.CLICK, ToggleOn.CONTEXT_MENU]}
                togglersIds={[this._contextMenuTriggerId]}
                popupClassName={cx('menuPopover')}
                popupAnchor={PopupAnchor.RightTop}
                sourceAnchor={SourceAnchor.RightBottom}
                dataSource={this._getMenuItems(page)}
                itemRenderer={OverlaysMenu._renderItem}
                theme={{
                    'contextMenu': cx('contextMenuTriggerWrapper'),
                    'content': cx('content')
                }}
            >
                <button id={this._contextMenuTriggerId} className={cx('menuIcon', {className: !!className})}>
                    <ImgIcon
                        icon={ImgIcons.multiValues}
                    />
                </button>
            </ContextMenu>
        );
    }
}
